import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-photo-selector-input',
  templateUrl: './photo-selector-input.component.html',
  styleUrls: ['./photo-selector-input.component.scss']
})
export class PhotoSelectorInputComponent implements OnInit, OnChanges {

  @Input() placeholder: string;
  @Input() photos: any;
  @Input() path: string;
  @Input() download = false;

  label: string;

  constructor(private translateService: TranslateService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.photos && this.photos.selectedImages) {
      this.label = this.photos.selectedImages.length
                  .toString()
                  .concat(this.translateService.instant('admin.toolMaintenancePlans.tasks.createModal.photoModal.label'));
    }
  }
}
